export default {
  credentialsModal: {
    kioskCode: "Device Code",
    password: "Password",
    qrHelp:
      "Scan this QR from the tablet login screen to auto-fill credentials.",
    securityWarningTitle: "Security warning:",
    securityWarningBody:
      "anyone who scans this QR can log in until you regenerate the password.",
  },
  posConfig: {
    title: "Link a reader",
    linkedReaderTitle: "Linked reader",
    readerId: "Provider reader id",
    refreshFromSumup: "Refresh from SumUp",
    disconnect: "Unlink",
    replaceWithNewPairing: "Replace with another reader",
    searchSerialPlaceholder: "Search by serial number…",
    showMockReaders: "Show mock terminals",
    noAvailableReaders:
      "No linkable readers found. Pair a SumUp reader in Reader management first.",
    selectReaderRequired: "Select an available reader by serial number.",
    linkReplace: "Link & replace",
    linkReader: "Link reader",
    linkMockReader: "Link mock reader",
    unlinkConfirm:
      "Unlink this reader from the tablet? Pairing with SumUp is kept; payments stay disabled until you link again.",
  },
} as const;
